import { z } from "zod";
const SectionSpacingSchema = z.object({
  spacing: z.object({
    top: z.string(),
    bottom: z.string()
  }).optional().nullable()
});
const TextAlignSchema = z.enum(["left", "right", "center"]);
export { SectionSpacingSchema, TextAlignSchema };
